<template>

    <div class="mb-0 d-flex text-center justify-content-center" v-if="marcacao && marcacao.item_status && marcacao.item_status.etapas" 
        id="etapas-atendimento">
        <div class="ml-2 mr-1 mb-0">
            <a class="badge badge-pill" v-if="iniciar" href="#"
                :class="( etapa >= 1 || marcacao.item_status.etapas.e1 ) ? 'badge-success' : 'badge-secondary'"
                title="Dados do Paciente"
                @click.prevent="iniciar ? $emit('click', marcacao, 1) : ''">
                <i class="fas fa-user fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>

            <span class="badge badge-pill" v-else title="Dados do Paciente"
                :class="( etapa >= 1 || marcacao.item_status.etapas.e1 ) ? 'badge-success' : 'badge-secondary'">
                <i class="fas fa-user fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <div class="mr-1 mb-0">
            <a class="badge badge-pill" v-if="iniciar"
                :class="( etapa >= 2 || marcacao.item_status.etapas.e2 ) ? 'badge-success' : 'badge-secondary'"
                title="Procedimentos" href="#"
                @click.prevent="iniciar && marcacao.item_status.etapas.e1 ? $emit('click', marcacao, 2) : ''">
                <i class="fas fa-list-ul fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else title="Procedimentos"
                :class="( etapa >= 2 || marcacao.item_status.etapas.e2 ) ? 'badge-success' : 'badge-secondary'">
                <i class="fas fa-list-ul fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <!-- Pagamento -->
        <div class="mr-1 mb-0" v-if="is_particular(marcacao)">
            <a class="badge badge-pill" v-if="iniciar" href="#"
                :class="marcacao.item_status.etapas.e3 ? 'badge-success' : 'badge-secondary'"
                title="Pagamento"
                @click.prevent="iniciar && marcacao.item_status.etapas.e2 ? $emit('click', marcacao, 3) : ''">
                <i class="fas fa-dollar-sign fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="marcacao.item_status.etapas.e3 ? 'badge-success' : 'badge-secondary'"
                title="Pagamento">
                <i class="fas fa-dollar-sign fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>

        <!-- Pagamento em Operadora -->
        <div class="mr-1 mb-0" v-else-if="marcacao && marcacao.atendimento && marcacao.atendimento.pagamento_atendimento_count"> <!-- !marcacao.atendimento.fl_reembolso && -->
            <a class="badge badge-pill" v-if="iniciar" href="#"
                :class="marcacao.item_status.etapas.e3 ? 'badge-success' : 'badge-secondary'"
                title="Pagamento"
                @click.prevent="iniciar && marcacao.item_status.etapas.e2 ? $emit('click', { 
                    ...marcacao,
                    fl_particular: true 
                }, 3) : ''">
                <i class="fas fa-dollar-sign fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="marcacao.item_status.etapas.e3 ? 'badge-success' : 'badge-secondary'"
                title="Pagamento">
                <i class="fas fa-dollar-sign fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>

        <!-- Recibo -->
        <div class="mr-1 mb-0" v-if="marcacao && ( is_particular(marcacao) || ( marcacao.atendimento && !marcacao.atendimento.fl_reembolso && marcacao.atendimento.pagamento_atendimento_count ) )">
            <a class="badge badge-pill" v-if="iniciar" href="#"
                :class="marcacao.item_status.etapas.e3 
                    ? ( na_recepcao ? 'badge-warning' : 'badge-success' ) 
                    : 'badge-secondary'"
                title="Recibo"
                @click.prevent="iniciar && marcacao.item_status.etapas.e3 ? $emit('click', marcacao, 4) : ''">
                <i class="fa-solid fa-receipt fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="marcacao.item_status.etapas.e3 
                    ? ( na_recepcao ? 'badge-warning' : 'badge-success' ) 
                    : 'badge-secondary'"
                title="Recibo">
                <i class="fa-solid fa-receipt fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <!-- Não iniciado -->
        <div class="mr-1 mb-0" v-if="!( marcacao && is_particular(marcacao) )">
            <a class="badge badge-pill" v-if="iniciar"
                :class="marcacao.item_status.etapas.e8 
                    ? ( na_recepcao ? 'badge-warning' : 'badge-success' )
                    : 'badge-secondary'"
                title="Guias Geradas"
                href="#"
                @click.prevent="iniciar && marcacao.item_status.etapas.e2 ? $emit('click', marcacao, 8) : ''">
                <i class="far fa-file-alt fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="marcacao.item_status.etapas.e8 
                    ? ( na_recepcao ? 'badge-warning' : 'badge-success' ) 
                    : 'badge-secondary'"
                title="Guias Geradas">
                <i class="far fa-file-alt fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <slot name="pos-etapas"></slot>
    </div>

</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    props: ['marcacao', 'etapa', 'iniciar', 'total'],

    computed: { 
        na_recepcao: function () { 
            if ( !this.marcacao || !this.marcacao.item_status ) { 
                return false; 
            }

            return this.marcacao.item_status.na_recepcao;
        }
    },

    methods: { 

        is_particular(marcacao) { 
            return ( marcacao && marcacao.plano && marcacao.plano.id_operadora == 1 ) ? true : false;
        },

        check_etapa (etapa) { 

            if ( this.etapa && this.etapa >= etapa )
                return true;

            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( !this.marcacao.atendimento )
                return false;

            let teste = _.findIndex (this.marcacao.atendimento.progresso_atendimentos, item => { 
                return item.id_etapa_atendimento == etapa;
            });
            return teste >= 0;
        }
        
    }
}
</script>

<!-- 
<div class="mb-0 d-flex text-center justify-content-center" v-if="marcacao" id="etapas-atendimento">
        <div class="ml-2 mr-1 mb-0">
            <a class="badge badge-pill" v-if="iniciar"
                :class="check_etapa (1) ? 'badge-success' : 'badge-secondary'"
                href="#"
                data-toggle2="tooltip" data-placement="top" title="Dados do Paciente"
                @click.prevent="iniciar ? $emit('click', marcacao, 1) : ''">
                <i class="fas fa-user fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>

            <span class="badge badge-pill" v-else
                :class="check_etapa (1) ? 'badge-success' : 'badge-secondary'"
                data-toggle2="tooltip" data-placement="top" title="Dados do Paciente">
                <i class="fas fa-user fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <div class="mr-1 mb-0">
            <a class="badge badge-pill" v-if="iniciar"
                :class="check_etapa (2) ? 'badge-success' : 'badge-secondary'"
                title="Procedimentos" href="#"
                @click.prevent="iniciar && check_etapa(1) ? $emit('click', marcacao, 2) : ''">
                <i class="fas fa-list-ul fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="check_etapa (2) ? 'badge-success' : 'badge-secondary'"
                data-toggle2="tooltip" data-placement="top" title="Procedimentos">
                <i class="fas fa-list-ul fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <div class="mr-1 mb-0" v-if="marcacao && marcacao.fl_particular == 1">
            <a class="badge badge-pill" v-if="iniciar" href="#"
                :class="check_etapa (3) ? 'badge-success' : 'badge-secondary'"
                title="Pagamento"
                @click.prevent="iniciar && check_etapa(2) ? $emit('click', marcacao, 3) : ''">
                <i class="fas fa-dollar-sign fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="check_etapa (3) ? 'badge-success' : 'badge-secondary'"
                title="Pagamento">
                <i class="fas fa-dollar-sign fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <div class="mr-1 mb-0" v-else>
            <a class="badge badge-pill" v-if="iniciar"
                :class="check_etapa (8) 
                    ? ( na_recepcao ? 'badge-warning' : 'badge-success' )
                    : 'badge-secondary'"
                title="Guias Geradas"
                href="#"
                @click.prevent="iniciar && check_etapa(2) ? $emit('click', marcacao, 8) : ''">
                <i class="far fa-file-alt fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </a>
            <span class="badge badge-pill" v-else
                :class="check_etapa (8) 
                    ? ( na_recepcao ? 'badge-warning' : 'badge-success' ) 
                    : 'badge-secondary'"
                title="Guias Geradas">
                <i class="far fa-file-alt fa-fw" :class="etapa ? 'fa-2x' : ''"></i>
            </span>
        </div>
        <slot name="pos-etapas"></slot>
    </div>
    -->